module.exports = __webpack_public_path__ + "img/NFT_on.271960b2.png";